import React from 'react';
import { connect } from "react-redux";
import createNapUredaj from './../../../API/Admin/CreateNapUredaj.js'
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import Dropdown from 'react-dropdown';
import businessPremisesList from './../../../API/Admin/GetBusinessPremisesList'
import Loader from './../../../Global/loader'

class CreatePosProstor extends React.Component {
    constructor(props) {
        super(props); 
        this.submitCreate = this.submitCreate.bind(this);
    }

    state={
        tid: "",
        label: "",
        isuNumber: "",
        description: "",
        businessPremisesUuid: "",
        listPosProstoOption: [],
        loading: true,
        pickedPosProstor: {},
        ecommerce: false
    }

    componentDidMount = async () => {
        this.setState({
            loading: true
        })
        const lista = await businessPremisesList(this.props.oneClientInfo.uuid)
        if(lista.data.length > 0){
            this.props.mapState("ADMIN_MAP_POS_PRO_LIST", lista.data)
        }

        let propsOption =  []
        this.props.posProstorList.map((data) => (
            propsOption.push({label: data.premises_name, value: data.uuid})
        ))

        this.setState({
            listPosProstoOption: propsOption,
            loading: false
        }) 
    }

    
    handleChange(e){
        this.setState({
            [e.target.id]: e.target.value
        })
    }
    
    // dropdown poslovni prostor
    setPosProstor = async (data) => {
        this.props.posProstorList.filter(devices => devices.uuid === data.value).map(filteredData => (
            //this.props.mapState("CLIENT_MAP_PICKED_POS_PROSTOR", filteredData)
            
            this.setState({
                pickedPosProstor : filteredData
            })
        ))
    }
    

    submitCreate = async (e) => {
        this.setState({ loading: true })
        e.preventDefault()
        let createPP = await createNapUredaj(this.props.oneClientInfo.uuid, this.state.tid, this.state.label, this.state.description, this.state.isuNumber, this.state.pickedPosProstor.uuid, this.state.ecommerce)
        
        if(createPP.data.status === 400){ 
            store.addNotification({
                title: "Greška!",
                message: createPP.data.message,//"Došlo je do pogreške prilikom kreiranja naplatnog uređaja, molimo pokušajte ponovno.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({ loading: false })
        }
        else{
            alert("OTP uređaja: " + createPP.data.data.otp)
            store.addNotification({
                title: "Uspješno!",
                message: "Kreiranje naplatnog uređaja je završeno",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });

            this.props.goBack()
        }        
    }
   

    handleEcommerce = async () => {
        this.setState({
            ecommerce: !this.state.ecommerce
        })
    } 

    render(){  
        return (
            <>
                {this.state.loading ?
                <div style={{position: "sticky", marginTop: "50px", left: "50%"}}>
                    <Loader />
                </div>
                :
                <form style={{padding: "40px"}}>
                    <div className="row">          
                        <div className="col col-sm-12 col-lg-6 col-md-12">
                            <div className="form-group row">
                                <label htmlFor="label" className="col-sm-4 col-form-label">TID</label>
                                <div className="col-sm-8">
                                    <input      
                                            id="tid"                          
                                            type="text"
                                            value={this.state.tid}
                                            onChange={e => this.handleChange(e)}
                                        />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="address" className="col-sm-4 col-form-label">Oznaka</label>
                                <div className="col-sm-8">
                                    <input
                                        id="label"  
                                        type="text"
                                        value={this.state.label}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="description" className="col-sm-4 col-form-label">Opis</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="description"                         
                                        type="text"
                                        value={this.state.description}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </div>
                            </div>  

                            <div className="form-group row">
                                <label htmlFor="premises_name" className="col-sm-4 col-form-label">ISU</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="isuNumber"                         
                                        type="text"
                                        value={this.state.isuNumber}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </div>
                            </div> 

                            <div className="form-group row">
                                <label htmlFor="listPosProstoOption" className="col-sm-4 col-form-label">Poslovni prostor</label>
                                <div className="col-sm-8">
                                    {this.state.loadingPosProList ? 
                                        <input 
                                            disabled
                                            value={""}
                                            placeholder="Učitavanje..."
                                            type="text"
                                        />
                                    :
                                        <Dropdown 
                                            isClearable= {true}
                                            placeholder="Molim odaberite" 
                                            options={this.state.listPosProstoOption} 
                                            onChange={this.setPosProstor} 
                                            //value={this.state.nazNapUred} 
                                            value={this.state.pickedPosProstor.premises_name ? this.state.pickedPosProstor.premises_name: ""}
                                        />
                                    }
                                </div> 
                            </div> 
                            <div className="form-group row" style={{ alignItems: 'center' }}>
                                <label htmlFor="E-commerce" className="col-sm-4 col-form-label">E-commerce</label>
                                <div className="col-sm-8">
                                    <label className="form-check-label" htmlFor="ecommerce">
                                        <input      
                                            id="ecommerce"                                          
                                            type="checkbox"
                                            checked={this.state.ecommerce}
                                            onChange={e => this.handleEcommerce(e)}
                                        />
                                        &nbsp;&nbsp; e-commerce
                                    </label>
                                </div>
                            </div>

                            <div className="col-sm-4" style={{float:"right",padding: "0px"}}>
                                <button                                    
                                    className="btn btn-info" 
                                    style={{padding:"10px"}} 
                                    onClick={(e) => this.submitCreate(e)}
                                >
                                    Spremi
                                </button>
                            </div>                                  
                        </div>                        
        
                        
                    </div>           
                    
                    <div 
                        className="btn btn-default" 
                        style={{/*width: "100%",*/ marginBottom: "10px", marginTop: "10px"}}
                        onClick={() => this.props.goBack()}
                    >
                        <BsBackspaceFill size={30} />  <strong>Nazad</strong>
                    
                    </div>    
                
                </form>
                }  
            </>

        )
    }
}
const mapStateToProps = state => {
    return {
        oneClientInfo: state.adminClient.oneClient,
        posProstorList: state.adminClient.posProstorList,
        onePosPro: state.adminClient.onePosPro
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(CreatePosProstor);


